// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_dh-b";
export var colorBlue = "_dh-8";
export var colorDot = "_dh-0";
export var colorDotLarge = "_dh-2";
export var colorDotSmall = "_dh-1";
export var colorGreen = "_dh-7";
export var colorGrey = "_dh-3";
export var colorOrange = "_dh-5";
export var colorPink = "_dh-a";
export var colorPurple = "_dh-9";
export var colorRed = "_dh-4";
export var colorYellow = "_dh-6";